export const CommunityRole = {
	OWNER: "owner",
	ADMIN: "admin",
	MODERATOR: "moderator",
	MEMBER: "member",
} as const;
export type CommunityRole = (typeof CommunityRole)[keyof typeof CommunityRole];

export const MemberStatus = {
	PENDING: "pending",
	APPROVED: "approved",
	REJECTED: "rejected",
	BANNED: "banned",
	INVITED: "invited",
} as const;
export type MemberStatus = (typeof MemberStatus)[keyof typeof MemberStatus];

export const CommunityFeature = {
	FEED: "feed",
	MESSAGES: "messages",
	MEMBERS: "members",
	MEETINGS: "meetings",
	EVENTS: "events",
	VIDEOS: "videos",
} as const;
export type CommunityFeature = (typeof CommunityFeature)[keyof typeof CommunityFeature];

export const MemberListFilter = {
	ACTIVE: "active",
	PENDING: "pending",
	INVITED: "invited",
} as const;
export type MemberListFilter = (typeof MemberListFilter)[keyof typeof MemberListFilter];

export const AdminMemberFilter = {
	ALL: "all",
	PENDING: "pending",
	INVITED: "invited",
} as const;
export type AdminMemberFilter = (typeof AdminMemberFilter)[keyof typeof AdminMemberFilter];

export const InvitationStatus = {
	PENDING: "pending",
	ACCEPTED: "accepted",
	EXPIRED: "expired",
} as const;
export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const LegalKind = {
	PRIVACY: "privacy",
	TERMS_OF_USE: "terms-of-use",
} as const;
export type LegalKind = (typeof LegalKind)[keyof typeof LegalKind];
